import { string } from 'yup'

const passwordField = message => string().min(8, message || 'Please enter a password of a minimum of 8 characters')

export default passwordField
